module.exports = __webpack_public_path__ + "img/setplexLogo.eaa568.png";